export { default } from './BadgeVideoReview';
